var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carrier === 'ktj' || _vm.carrier === 'ty')?_c('div',[_vm._v(" 倉庫完成打包後，一件宅配包裹加收300元台幣， 以貨到付款方式收取。 ")]):_c('div',[_vm._v(" 集運重量1~5公斤加收90元台幣，5公斤以上加收110元台幣， 下單時與集運費用一同收取。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }